export default __webpack_public_path__ + "assets/mobapps.0ae9ff90c1edb0c5458fc28a10cf23ff.png";